<template>
  <TxtPage>
    
    <div slot="return-content" class="btn-return">
      <router-link :to="{ name: 'Appartement' }">
        <img src="../../assets/arrow.svg" />
      </router-link>    
    </div>
    
    <div slot="left-content" class="spacer-content text-center">
      <div class="title-light">UN CONFORT EXTÉRIEUR DES PLUS EN VUE</div>
      <div class="line"></div>
      <div class="text"><strong>Disposer d’un espace extérieur privatif est devenu un privilège rare en ville et notamment à Paris.</strong></div>
      <div class="text mt40">Les appartements d’Air du Temps dévoilent de grandes baies vitrées, véritables incarnations de la transparence, qui attirent le regard vers l’extérieur et vous invitent à apprécier pleinement les vues dégagées qui s’offrent à vous.</div>
      <div class="text mt40">Depuis votre balcon, loggia ou terrasse à ciel ouvert, dont les dimensions peuvent atteindre jusqu’à 78 m2, vous ne vous lasserez pas de contempler ce panorama exceptionnel sur la ville, ou le cœur d’îlot paysager.</div>
    
      <div class="btn-scroll"><img src="../../assets/scroll.svg" /></div>
    </div>
    
    <div slot="right-content">
      <img src="../../assets/pers-appartement-exterieurs.jpg" class="cover-center"/>
    </div>
    
  </TxtPage>
</template>

<style lang="scss" scoped>
title-book {
    font-size: 32px;
    text-align: center;
    font-family: 'FuturaStd-Book';
  }
  .title-light {
    font-size: 32px;
    text-align: center;
    margin-bottom: 40px;
  }
  .text {
    .list-style-custom {
      margin: 0 !important;
    }
    margin-bottom: 0 !important;
  }  
  .mt40 {
    margin-top: 40px;
  }
  
  .cover-center{
    @media (min-width: 992px) {
      -o-object-position: -25% !important;
      object-position: -25% !important;
    }
  }
</style>

<script>
import TxtPage from '@/components/TxtPage.vue';
// @ is an alias to /src

export default {
    name: 'VosExterieurs',
    components: {
        TxtPage,
    },
    data: () => {
    
        return {
        
            links: [
            ],
            visible: true
        
        };
    }

    
}
</script>